import { Swiper } from 'swiper';

class BlockSliderLogos {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-logos__swiper', {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: true,
      speed: 3000,
      autoplay: {
        delay: 10,
        disableOnInteraction: false
      }
    });
  }
}

export const blockSliderLogos = new BlockSliderLogos();
